export enum EOrderStatus {
    "CREATED" = "Створено",
    "PAYED" = "Оплачено",
    "PAYMENT-FAILED" = "Помилка оплати",
    "DELIVERED" = "Доставлено",
    "CANCELED" = "Скасовано"
}
